import { create } from "zustand";
import api from "./api";

export const useAuth = create((set) => ({
  admin: null,
  env: "DEV",
  status: "checking", // 'checking' | 'authed' | 'guest'
  bootstrap: async () => {
    try {
      const { data } = await api.get("/admin/auth/me");
      set({ admin: data.admin, env: data.env, status: "authed" });
    } catch {
      set({ admin: null, status: "guest" });
    }
  },
  login: async (email, password) => {
    const { data } = await api.post("/admin/auth/login", { email, password });
    const me = await api.get("/admin/auth/me");
    set({ admin: data.admin, env: me.data.env, status: "authed" });
  },
  logout: async () => {
    try {
      await api.post("/admin/auth/logout");
    } catch {
      // ignore
    }
    set({ admin: null, status: "guest" });
  },
}));
